import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { SERVICE_CARDS } from '../mock';

export default function ServicesIntro() {
  return (
    <section id="uslugi" className="relative bg-[#132a44] text-white py-24 md:py-28 overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-40 pointer-events-none" />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-7">
            <div className="text-[12px] font-semibold tracking-[0.25em] text-[#f5c518] mb-6">KOMPLEKSOWE USŁUGI INŻYNIERYJNE</div>
            <h2 className="font-heading font-extrabold text-[38px] md:text-[52px] leading-[1.05] tracking-tight">
              Jedna wiedza. Wiele obszarów inżynierii.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-white/75 text-[15px] leading-relaxed">
              Świadczę kompleksowe usługi inżynieryjne w zakresie automatyki przemysłowej oraz instalacji i robót elektrycznych. Łączę wiedzę projektową, wykonawczą i nadzorczą, pomagając inwestorom oraz firmom przemysłowym podejmować właściwe decyzje techniczne.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICE_CARDS.map((c) => (
            <a key={c.letter} href="#uslugi" className="group relative rounded-2xl bg-white/[0.04] hover:bg-white/[0.07] border border-white/10 p-7 transition-colors">
              <div className="flex items-start justify-end">
                <ArrowUpRight className="h-5 w-5 text-white/50 group-hover:text-[#f5c518] transition-colors" />
              </div>
              <h3 className="mt-10 font-heading font-bold text-[20px] tracking-tight">{c.title}</h3>
              <p className="mt-3 text-[14px] text-white/70 leading-relaxed">{c.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
